<template>
  <div class="experience d-flex flex-column align-items-start position-relative">
    <div class="d-flex flex-column gap-1">
      <span class="fs-5 fw-semibold text-white">
        {{ value }}
        <span v-if="sign">{{ sign }}</span>
      </span>

      <div class="d-flex align-items-center gap-2">
        <span class="small text-white">{{ title }}</span>

        <i
          v-if="hasLink"
          class="bi bi-arrow-up-right text-white small ms-1 translate-start"
        ></i>
      </div>
        
    </div>
    
  </div>
</template>

<script>
export default {
  name: "Experience",
  props: {
    value: String,
    title: String,
    sign: {
      type: String,
      default: "+",
    },
    hasLink: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.experience {
  transition: all 0.3s ease;
}
.experience:hover .bi-arrow-up-right {
  transform: translateX(0);
  opacity: 1;
}
.bi-arrow-up-right {
  transform: translateX(-10px);
  opacity: 0;
  transition: all 0.3s ease;
}
</style>
